import { createI18n } from "vue-i18n";
import es from "@/locales/es.json";
import gl from "@/locales/gl.json";
import { APP_CONFIG } from "@/config/app-config";

const messages = { es, gl };

const saved = typeof localStorage !== "undefined" ? localStorage.getItem("anpa_locale") : null;
const initial =
  saved && saved in messages
    ? saved
    : APP_CONFIG.locale in messages
      ? APP_CONFIG.locale
      : "gl";

const i18n = createI18n({
  legacy: false,
  locale: initial,
  fallbackLocale: "es",
  messages,
});

export default i18n;
